import React, { useState } from "react";
// import { ModalEditItem } from "../modalEditItem/modal";
import { Button } from "react-bootstrap";
import { ModalAddItem } from "./modal";

export function AddItemModal({name, disabled}){
  const [show, setShow] = useState(false)
  return (
    <>
      <ModalAddItem name={name} show={show} setShow={setShow}/>
      <Button disabled={disabled} onClick={()=>setShow(true)}>
        Add
      </Button>
    </>
  )



}